module.exports = __webpack_public_path__ + "static/media/newswatch.7c352eda.svg";